import { createFileRoute, Link, redirect } from "@tanstack/react-router";

import { env } from "@/env";
import { icons } from "@/ui";
import { PersonifyButton } from "./-components";

const BENEFITS = [
  "Earn Personify Health rewards",
  "No separate EO password to remember",
  "Clinician-led, personalized cannabinoid care",
];

const PersonifyGetStarted = () => {
  return (
    <div className="flex min-h-screen items-center justify-center bg-gradient px-6 py-12">
      <div className="w-full animate-fade-in sm:w-105">
        <div className="flex flex-col items-center gap-7">
          <div className="flex items-center justify-center gap-4">
            <icons.EOCareIcon className="w-14" />
            <span className="text-2xl text-content-subtle">+</span>
            <img
              alt="Personify Health"
              className="size-11 -rotate-[8deg]"
              src="/assets/images/personify-percy.png"
            />
          </div>

          <div className="flex flex-col items-center text-center">
            <h1 className="text-3xl font-extrabold tracking-tight">{`Let's Begin`}</h1>
            <p className="mt-3 text-base text-content-secondary">
              {`You're moments away from a personalized`}
              <br />
              <span className="whitespace-nowrap">EO Care Plan</span>, built by clinicians.
            </p>
          </div>

          <ul className="mx-auto flex max-w-sm flex-col gap-3 text-left">
            {BENEFITS.map((text) => {
              return (
                <li className="flex items-start gap-3" key={text}>
                  <span className="mt-0.5 flex size-5.5 shrink-0 items-center justify-center rounded-full bg-accent-surface text-accent">
                    <icons.CheckIcon className="size-3" />
                  </span>
                  {text}
                </li>
              );
            })}
          </ul>

          <PersonifyButton>Continue With Personify Health</PersonifyButton>

          <p className="text-center text-sm text-content-secondary">
            Not a Personify Health member?{" "}
            <Link
              className="border-b-2 border-accent font-semibold text-content hover:text-accent"
              to="/profiling"
            >
              Start Here
            </Link>
          </p>

          <p className="text-center text-sm text-content-subtle">
            Please consult with your doctor before beginning
            <br className="hidden sm:block" /> any cannabinoid treatments.
          </p>
        </div>
      </div>
    </div>
  );
};

export const Route = createFileRoute("/_guest/personify-get-started/")({
  beforeLoad: () => {
    if (env.VITE_PERSONIFY_ENABLED !== "true") {
      throw redirect({ to: "/" });
    }
  },
  component: PersonifyGetStarted,
});
